var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlthLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 860 433",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #706f6f;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: none;\n        opacity: .3;\n      }\n\n      .cls-3 {\n        fill: url(#Degradado_Alth-2);\n      }\n\n      .cls-4 {\n        fill: #000;\n      }\n\n      .cls-5 {\n        fill: url(#Degradado_Alth);\n      }\n\n      .cls-6 {\n        fill: #c6c6c6;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_Alth",
    "data-name": "Degradado Alth",
    x1: 96,
    y1: 170,
    x2: 202,
    y2: 170,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#1a1a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#343544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#484960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#565873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#5f617f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#626483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#596087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#435595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38509c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_Alth-2",
    "data-name": "Degradado Alth",
    x1: 140.28,
    y1: 227.68,
    x2: 243.13,
    y2: 124.84,
    xlinkHref: "#Degradado_Alth"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 860,
    height: 433
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "96 202 96 244 202 138 202 96 96 202"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "140.98 208.95 141 245 247 139 246.98 102.95 140.98 208.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "96.01 303.01 96 336 202 230 202.01 197.01 96.01 303.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "141.56 301.8 141.55 337 247.55 231 247.56 195.8 141.56 301.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M346.62,119h10.38l50.2,130h-10.57l-12.46-32.36h-65.3l-12.65,32.36h-10.23l50.62-130ZM322.83,207h58.17l-29.4-75.88-28.77,75.88Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "447.76 119.21 457.7 119.21 457.7 240.47 518.76 240.47 518.76 249.21 447.76 249.21 447.76 119.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "535.21 119.21 627.22 119.21 627.22 128.26 586.64 128.26 586.64 249.21 576.35 249.21 576.35 128.26 535.21 128.26 535.21 119.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "668.4 119.21 678.31 119.21 678.31 177.6 754.02 177.6 754.02 119.21 763.94 119.21 763.94 249.21 754.45 249.21 754.45 187 678 187 678 249.21 668.4 249.21 668.4 119.21"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "297 273 300.2 273 300.2 310.69 319.35 310.69 319.35 313.71 297 313.71 297 273"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M367.85,293.35c0,11.6-9.4,21-21,21s-21-9.4-21-21,9.4-21,21-21,21,9.4,21,21ZM346.85,275.35c-9.94,0-18,8.06-18,18s8.06,18,18,18,18-8.06,18-18-8.06-18-18-18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M391.15,273h3.25l15.72,40.71h-3.31l-3.9-10.13h-20.45l-3.96,10.13h-3.2l15.85-40.71ZM383.7,300.56h18.21l-9.21-23.76-9.01,23.76Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "421.54 313.71 424.6 313.71 424.6 278.58 448.61 313.71 451.37 313.71 451.37 273 448.31 273 448.31 308 424.23 273 421.54 273 421.54 313.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M490,310.7c3.1,1.05,8.92,1.2,12.7-1.7,1.3-1,3.02-4.12,2.3-7-1-4-5.89-6.37-11-7.7-5-1.3-8.79-2.99-10.63-5.45-1.37-1.85-2.37-5.72-1.27-8.85,3.44-9.83,19.9-11,25,.9,0,0-2.6,1.4-2.6,1.4-2.5-5.3-5.59-6.51-9.5-6.9s-9,1.6-10,5.6c-1.48,5.9,2.89,8.3,8,10,6,2,10,3,13,6s3,8,1.2,11c-1.2,2-2.89,3.95-5.2,5-7.43,3.38-18.96,1.1-22.05-8.25,0,0,3.05-1.75,2.7-1.55,1.35,5.8,7.35,7.5,7.35,7.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "544.05 275.9 544.05 273 520.9 273 520.9 313.72 544.31 313.72 544.31 310.8 524 310.8 524 295 542.6 295 542.6 291.75 524 291.75 524 276 544.05 275.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M557.25,273s15.75-.14,17.51,0c12.24,1,15.24,20,1.62,23.6.61.4,10.22,17.12,10.22,17.12h-3.63l-10.02-16.72h-12.71v16.72h-2.98v-40.72ZM560.35,275.9v18.2h14c11.65-2.1,9.65-17.1,0-18.2h-14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "593.38 273 596.87 273 610.15 309.6 623.61 273 627.22 273 611.91 313.72 608.65 313.72 593.38 273"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 638.34,
    y: 273,
    width: 3.15,
    height: 40.72
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "729.21 275.9 729.21 273 706.06 273 706.06 313.72 729.47 313.72 729.47 310.8 709.16 310.8 709.16 295 727.76 295 727.76 291.75 709.16 291.75 709.16 276 729.21 275.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M654.25,293.4c0-12.04,9.15-20.95,21.42-20.95,8.34,0,14.24,4.55,17.44,9.7l-2.65,1.55c-2.45-4.7-8.45-8.48-14.67-8.48-10.56,0-18.53,7.79-18.53,18.17s7.75,18.17,18.53,18.17c9.22,0,13.22-5.57,14.97-8.65l2.55,1.49c-3.3,5.59-9.3,9.93-17.64,9.93-12.27,0-21.42-8.91-21.42-20.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M749.75,310.7c3.1,1.05,8.92,1.2,12.7-1.7,1.3-1,3.02-4.12,2.3-7-1-4-5.89-6.37-11-7.7s-8.79-2.99-10.63-5.45c-1.37-1.85-2.37-5.72-1.27-8.85,3.44-9.83,19.9-11,25,.9,0,0-2.6,1.4-2.6,1.4-2.5-5.3-5.59-6.51-9.5-6.9-4-.4-9,1.6-10,5.6-1.48,5.9,2.89,8.3,8,10,6,2,10,3,13,6s3,8,1.2,11c-1.2,2-2.89,3.95-5.2,5-7.43,3.38-18.96,1.1-22.05-8.25,0,0,3.05-1.75,2.7-1.55,1.35,5.8,7.35,7.5,7.35,7.5Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlthLogoColor);
export default __webpack_public_path__ + "static/media/ALTHLogoColor.330d205a33162ea896a9a5ebb748b5c2.svg";
export { ForwardRef as ReactComponent };